module.exports = __webpack_public_path__ + "static/media/automated.e88654eb.svg";